import React from 'react'
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
interface LoginStore {
  mobileNumberState: string;
  setMobileNumberState: (mobileNumberState: string) => void;
}

const useLoginStore = create<LoginStore>()(persist((set, get) => ({
        mobileNumberState: '',
        setMobileNumberState: (mobileNumberState: string) => set((state)=>({
            mobileNumberState
        })),
}), {
    name: 'login-store',
    storage: createJSONStorage(() => localStorage),
}))

export default useLoginStore;
